// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterBody component
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';
import classnames from 'classnames';
import { resetStyleItem } from 'share/utils/Izenda.FilterDnDUtils';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import draggable from 'share/components/hoc/Izenda.Draggable';
import DnDFilterItemConfig from './Izenda.DnDFilterItemConfig';
import FilterItem from './Izenda.FilterItem';
import CONSTANTS from 'logic/data/Izenda.ReportDesignerConstants';
import { DEFAULT_DEBOUNCE_TIME } from 'logic/data/Izenda.UIConstants';
import { debounceLeading } from 'logic/models/Izenda.ReportUtils';

const DraggableItem = draggable(CONSTANTS.GENNERAL.FILTER_ITEM, DnDFilterItemConfig.sourceOptions);
const enhanceFilterItem = compose(DraggableItem);
const DnDFilterItem = enhanceFilterItem(FilterItem);

@observer
export default class FilterBody extends Component {
  doesCanDropFieldItem(itemType: string, canAccess: boolean, isOver: boolean) {
    if (itemType === CONSTANTS.GENNERAL.FIELD_ITEM) {
      return canAccess && isOver;
    }
    return false;
  }

  doesCannotDropFieldItem(itemType: string, canAccess: boolean, isOver: boolean) {
    if (itemType === CONSTANTS.GENNERAL.FIELD_ITEM) {
      return !canAccess && isOver;
    }
    return false;
  }

  doesCannotDropFilterItem(itemType: string, isOver: boolean) {
    if (itemType === CONSTANTS.GENNERAL.FILTER_ITEM) {
      return !isOver;
    }
    return false;
  }

  clearFieldDetails = debounceLeading(DEFAULT_DEBOUNCE_TIME, () => {
    const {
      store: { reportFilters }
    } = this.props;
    reportFilters.configField.fieldDetails = {};
  });

  componentWillReceiveProps(nextProps: any) {
    // Remove indicator for drag and drop when leave the drop target
    if (this.props.isOver && !nextProps.isOver) {
      const { store: { reportFilters }} = this.props;
      resetStyleItem(reportFilters.filterFields);
    }
  }

  render() {
    const props = this.props;
    const { store, filterFields, viewMode, itemType, isOver, showPosition = true } = this.props;

    const canAccess = props.canAccess && props.canAccess(props.item);
    const FilterItemComponent = !viewMode ? DnDFilterItem : FilterItem;

    const classes = classnames('filter-body drop-container', {
      'can-drop': this.doesCanDropFieldItem(itemType, canAccess, isOver),
      'cannot-drop':
        this.doesCannotDropFieldItem(itemType, canAccess, isOver) || this.doesCannotDropFilterItem(itemType, isOver)
    });

    let dataIndex = -1;
    return (
      <GridLayout className={classes}>
        <GridLayout.Row className='u_fullHeight u_noMarginAll'>
          <ScrollBox onScroll={this.clearFieldDetails}>
            {filterFields.map(field => {
              if (field.displayable) {
                dataIndex++;
                return (
                  <FilterItemComponent
                    key={field.uniqueId}
                    itemData={field}
                    store={store}
                    itemDataIndex={dataIndex}
                    showPosition={showPosition}
                    onBeforeDrag={this.clearFieldDetails}
                  />
                );
              }
              return null;
            })}
          </ScrollBox>
        </GridLayout.Row>
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.FilterBody.js